/** `PUT /spaces` refuses "one show" on a space with two or more: the message goes under the choice. */
export const showsModeApiErrors = (err: unknown): { mode: string } | null => {
  const data = (err as { response?: { status?: number; data?: { message?: string; errors?: { param?: string; message?: string }[] } } } | null)?.response
  const hit = data?.data?.errors?.find((e) => e.param === 'moduleConfig.mode' || e.param === 'mode')
  if (!hit) return null
  return { mode: hit.message || data?.data?.message || '' }
}
